module.exports = __webpack_public_path__ + "img/socialbg.22d6896e.jpg";